<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        Withdrawal
    </ng-container>

    <ng-container dialog-process-in-progress>
        <ng-container *ngIf="!paymentMethod; else formContainer">
            <div class="page-body d-flex flex-column">
                <div class="container-fluid">
                    <div class="row">
                        <div
                            appCheckPermissionRule

                            [rule]="data.withdrawalPermissionRule"

                            (click)="selectPaymentMethod(paymentMethods.BankTransfer)"

                            [ngClass]="{
                                'cursor-pointer': (data.linkedAccounts.length > 0)
                                    && (data.account.accountStatus === tradingAccountStatuses.Active)
                                }"

                            class="col-4 offset-1 text-center item"
                        >
                            <i
                                [ngClass]="{
                                    'text-muted': (data.linkedAccounts.length === 0) ||
                                        (data.account.accountStatus !== tradingAccountStatuses.Active)
                                }"

                                class="fa fa-3x fa-bank d-block text-primary"
                            ></i>
                            <span class="text">Bank</span>
                        </div>
                        <div
                            *ngIf="visibleTransferButton"
                            (click)="selectPaymentMethod(paymentMethods.InternalTransfer)"
                            [ngClass]="{'cursor-pointer': (data.tradingAccounts.length > 1)}"
                            class="col-4 offset-1 text-center item"
                        >
                            <i
                                [ngClass]="{'text-muted': ([0, 1].indexOf(data.tradingAccounts.length) >= 0)}"

                                class="fa fa-3x fa-exchange d-block text-primary"
                            ></i>
                            <span class="text">Internal</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #formContainer>
            <form [formGroup]="withdrawalForm.form" autocomplete="off">
                <div [ngClass]="{'mb-4': withdrawalForm.controls[0].errors.length > 0}">
                    <app-panel-input
                        [formControlName]="withdrawalForm.controls[0].name"
                        [control]="withdrawalForm.controls[0]"
                    ></app-panel-input>
                </div>

                <div class="row transfer-details-wrapper">
                    <div class="col-lg-10">
                        <div class="card">
                            <div class="card-body"  *ngIf="data.balanceData?.cashBalances">
                                <span class="label">Balance</span>
                                <ng-container *ngFor="let item of data.balanceData.cashBalances;">
                                    <div class="row">
                                        <div class="col-12 col-lg">
                                                    <span class="value">{{ item?.netCash | formatMultiCurrency:'': 2: 2 }} {{item?.currency}}</span>

                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto d-flex justify-content-center">
                        <a
                            (click)="getAccountDetails(data.account.accountId, true)"
                            href="javascript:void(0);" class="cursor-pointer text-primary  d-inline-block pt-lg-3 px-2">
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>

                <div
                    [ngClass]="{
                        'mb-4': accountTo && (paymentMethod === paymentMethods.InternalTransfer) && (withdrawalForm.controls[1].errors.length > 0),
                        'mb-3': (
                                    !accountTo &&
                                        (paymentMethod === paymentMethods.InternalTransfer) &&
                                            (withdrawalForm.controls[1].errors.length > 0)
                                ) || (
                                    (paymentMethod === paymentMethods.BankTransfer) &&
                                        (withdrawalForm.controls[1].errors.length > 0)
                                )
                    }"
                >
                    <app-autocomplete
                        [formControlName]="withdrawalForm.controls[1].name"
                        [control]="withdrawalForm.controls[1]"

                        (ngModelChange)="(paymentMethod === paymentMethods.InternalTransfer) && getAccountDetails($event)"
                    ></app-autocomplete>
                </div>

                <div
                    *ngIf="(paymentMethod === paymentMethods.InternalTransfer) && accountTo"

                    class="row transfer-details-wrapper"
                >
                    <div class="col-lg-10">
                        <div class="card">
                            <div class="card-body"  *ngIf="accountTo?.balance?.cashBalances">
                                <span class="label">Balance</span>
                                <ng-container  *ngFor="let item of accountTo.balance.cashBalances;">
                                    <div class="row">
                                        <div class="col-12 col-lg">
                                            <span class="value">{{ item?.netCash | formatMultiCurrency:'': 2: 2 }} {{item?.currency}}</span>

                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto d-flex justify-content-center">
                        <a
                            (click)="getAccountDetails(accountTo.id)"
                            href="javascript:void(0);" class="cursor-pointer text-primary  d-inline-block pt-lg-3 px-2">
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>

                <div [ngClass]="{'mb-2': withdrawalForm.controls[3].errors.length > 0}">
                    <app-select
                        [control]="withdrawalForm.controls[3]"
                        [formControlName]="withdrawalForm.controls[3].name"
                    ></app-select>
                </div>
                <div [ngClass]="{'mb-2': withdrawalForm.controls[2].errors.length > 0}">
                    <app-amount-input
                        [formControlName]="withdrawalForm.controls[2].name"
                        [control]="withdrawalForm.controls[2]"
                    ></app-amount-input>
                </div>
            </form>
        </ng-template>
    </ng-container>
</app-dialog>
